/**
 * Honey Twigs - BYOB Bundle Cart Integrity Guard
 * 1. Safely removes entire bundle when "Remove Box" button (.scd-item__bundle-remove) is clicked.
 * 2. Purges orphaned ₹1 parent products if child items are removed.
 * 3. Intercepts checkout if an invalid ₹1 parent is in cart without child items.
 */
(function() {
  'use strict';

  var isBusy = false;

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(res) {
      if (!res.ok) throw new Error('Failed to load cart');
      return res.json();
    });
  }

  function postCartUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function(res) {
      if (!res.ok) throw new Error('Failed to update cart');
      return res.json();
    });
  }

  function refreshCartUI(cartData) {
    // If on /cart page, reload
    if (window.location.pathname.indexOf('/cart') !== -1) {
      window.location.reload();
      return;
    }

    // Refresh theme drawer HTML if present
    fetch('/?section_id=cart-drawer')
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newBody = doc.querySelector('.scd__body');
        var newSummary = doc.querySelector('.scd__summary');
        var curBody = document.querySelector('.scd__body');
        var curSummary = document.querySelector('.scd__summary');
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        if (newSummary && curSummary) curSummary.innerHTML = newSummary.innerHTML;
      })
      .catch(function(e) {
        console.warn('Cart drawer refresh error:', e);
      });
  }

  // Remove all items belonging to bundleId
  function removeBundle(bundleId, btn) {
    if (!bundleId || isBusy) return;
    isBusy = true;

    if (btn) {
      btn.textContent = 'Removing...';
      btn.style.pointerEvents = 'none';
    }

    fetchCart().then(function(cart) {
      var updates = {};
      var found = 0;

      cart.items.forEach(function(item) {
        var props = item.properties || {};
        if (props._bundle_id === bundleId) {
          updates[item.key] = 0;
          found++;
        }
      });

      if (found > 0) {
        return postCartUpdates(updates).then(function(newCart) {
          isBusy = false;
          refreshCartUI(newCart);
        });
      } else {
        isBusy = false;
      }
    }).catch(function(err) {
      isBusy = false;
      console.error('Error removing bundle:', err);
      if (btn) {
        btn.textContent = 'Remove Box';
        btn.style.pointerEvents = 'auto';
      }
    });
  }

  // Check cart for illegal ₹1 parent items and purge them unconditionally
  function purgeOrphanParents() {
    if (isBusy) return;

    fetchCart().then(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return;

      var updates = {};
      var needsPurge = false;

      cart.items.forEach(function(item) {
        var props = item.properties || {};
        var bId = props._bundle_id;
        var isParent = props._is_bundle_parent === 'true' || 
                       (item.price <= 100 && item.title.toLowerCase().indexOf('build your own') !== -1);

        // Any ₹1 item representing the BYOB box itself is illegal in the cart
        if (isParent || (item.price <= 100 && item.title.toLowerCase().indexOf('build your own') !== -1)) {
          updates[item.key] = 0;
          needsPurge = true;
        }
      });

      if (needsPurge) {
        isBusy = true;
        console.warn('BYOB Guard: Purging illegal ₹1 box item from cart:', updates);
        postCartUpdates(updates).then(function(newCart) {
          isBusy = false;
          refreshCartUI(newCart);
          try {
            localStorage.setItem('shopifyCart', JSON.stringify(newCart));
            if (newCart && newCart.items) {
              var srItems = newCart.items.map(function(itm) {
                return { productId: itm.product_id, variantId: itm.variant_id, quantity: itm.quantity };
              });
              localStorage.setItem('shopifyCartItems', JSON.stringify(srItems));
            }
          } catch (e) {}

          var prefetchIframe = document.getElementById('prefetch-iframe');
          if (prefetchIframe && window.checkoutBuyer) {
            prefetchIframe.src = window.checkoutBuyer + '?prefetch=true&t=' + Date.now();
          }

          window.postMessage({ trigger: 'sync-shopify-cart-token-request' }, '*');
        }).catch(function() {
          isBusy = false;
        });
      }
    }).catch(function() {
      // Ignore background errors
    });
  }

  // Initialize Safe Event Listeners
  function init() {
    // 1. Delegate click ONLY on .scd-item__bundle-remove
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.scd-item__bundle-remove');
      if (btn && btn.getAttribute('data-bundle-id')) {
        e.preventDefault();
        e.stopPropagation();
        removeBundle(btn.getAttribute('data-bundle-id'), btn);
      }
    }, false);

    // 2. Checkout & Cart button safety checks
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[name="checkout"], .scd__checkout, .shiprocket-headless, .cart-icon, .sf-cart-icon');
      if (trigger) {
        purgeOrphanParents();
      }
    }, false);

    // 3. Initial check on load
    setTimeout(purgeOrphanParents, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
